const ROUTE_LOADING_TYPE = {
  ROUTE_LAZY_LOADING: 'ROUTE_LAZY_LOADING',
  ROUTE_PERMISSION_CHECK: 'ROUTE_PERMISSION_CHECK',
};

const COMPANY_TYPE = {
  SERVICE_ADMINISTRATOR: 'SERVICE_ADMINISTRATOR',
  SERVICE_PROVIDER: 'SERVICE_PROVIDER',
  ADMIN: 'ADMIN',
};

const PERMISSIONS = {
  ADJUDICATE_CLAIMS: 'ADJUDICATE_CLAIMS',
  MODIFY_CLAIMS: 'MODIFY_CLAIMS',
  UNDERWRITER_APPROVE: 'UNDERWRITER_APPROVE',
  UNDERWRITER_REJECT: 'UNDERWRITER_REJECT',
};

const WIDGET_TYPE = {
  CLAIMS: 'CLAIMS',
  SERVICEJOB: 'SERVICEJOB',
  SERVICEJOBLIST: 'SERVICEJOBLIST',
};

const CLAIM_STATUS = {
  INC: 'INC',
  CAN: 'CAN',
  SUB: 'SUB',
  PAR: 'PAR',
  PUR: 'PUR',
  PWR: 'PWR',
  COR: 'COR',
  APP: 'APP',
  REJ: 'REJ',
  PAD: 'PAD',
  TRX: 'TRX',
};

const FIELD_TYPES = {
  AMOUNT: 'AMOUNT',
  PHONE: 'PHONE',
  PHONE_TYPE: 'PHONE_TYPE',
  DATE: 'DATE',
};

const PASSWORD = {
  MAX_LENGTH: 64,
  MIN_LENGTH: 8,
};

const APP_SUPPORTS_MULTI_LANGUAGE = false;

const CLAIM_APPROVE_CODE_OTHER = 'AO99';
const CLAIM_REJECT_CODE_OTHER = 'R999';
const CLAIM_REJECT_OVERRIDE_OTHER = 'MR99';

const HIDE_ADD_CLAIM_BUTTON_WHEN_STATUS = [
  'INCOMPLETE',
  'PENDING_ADMINISTRATOR_REVIEW',
  'CORRECTION_DRAFT',
];

const DYNAMIC_FORM_MODE = {
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  CREATE: 'CREATE',
};

export {
  DYNAMIC_FORM_MODE,
  CLAIM_REJECT_OVERRIDE_OTHER,
  CLAIM_APPROVE_CODE_OTHER,
  CLAIM_REJECT_CODE_OTHER,
  PASSWORD,
  COMPANY_TYPE,
  PERMISSIONS,
  CLAIM_STATUS,
  FIELD_TYPES,
  ROUTE_LOADING_TYPE,
  WIDGET_TYPE,
  APP_SUPPORTS_MULTI_LANGUAGE,
  HIDE_ADD_CLAIM_BUTTON_WHEN_STATUS,
};
